/**
 * Shared styling for read-only/disabled form fields
 * Creates grey background with no hover/focus effects
 */
export const READ_ONLY_FIELD_STYLES = {
    backgroundColor: '#f5f5f5',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e0e0e0',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e0e0e0',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e0e0e0',
    },
};
